<template>
  <v-navigation-drawer
      v-model="application.drawer"
      app
      clipped
      v-if="application.showMobileMenu"
  >
    <v-btn icon
           @click="application.drawer=false"
           color="customRaspBerry"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-btn icon color="customRaspBerry" :to="{name:'Home'}">
      <v-icon>mdi-home</v-icon>
    </v-btn>
    <v-list>
      <template
          v-for="(parentFilterableCategory) in $store.getters['channelCustomCategories/structuredFilterableCategories']">


        <v-list-group
            v-if="parentFilterableCategory.products_count !==0"
            :key="parentFilterableCategory.name"
            no-action
            class="customRaspBerry--text"
        >
          <template v-slot:activator>
            <v-list-item-content class="customRaspBerry--text">
              <v-list-item-title v-text="parentFilterableCategory.name"></v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="(childrenFilterableCategory) in parentFilterableCategory.childrens">
            <v-list-item
                v-if="childrenFilterableCategory.products_count !== 0"
                :key="childrenFilterableCategory.name"
                :to="{name:'Category',params:{parentFilterableCategoryId:parentFilterableCategory.id,childrenFilterableCategoryId:childrenFilterableCategory.id}}"
            >
              <v-list-item-content class="customRaspBerry--text">
                <v-list-item-title v-text="childrenFilterableCategory.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import StoreComputed from "@/mixins/StoreComputed";

export default {
  name: "Drawer",
  mixins: [StoreComputed],
  data: () => ({
    drawer: true,
    showMobileSearch: false,
    userMenu: false,
    productSearchString: '',
    keycloak: {},
    isMobile: false,
    showMobileMenu: false
  }),
}
</script>

<style scoped>

</style>